/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { socialProfileSuggestionResponseDtoSchema } from "./socialProfileSuggestionResponseDtoSchema";
import { z } from "zod/v4";

export const previewContactSocialProfilesResponseDtoSchema = z.object({
    "contactId": z.string(),
get "suggestions"(){
                return z.array(socialProfileSuggestionResponseDtoSchema)
              }
    })